import React, { useMemo } from "react";
import styles from "./topDonorCardPlace.module.scss";

type TTopDonorCardPlace = {
  value: number;
};

const TopDonorCardPlace: React.FC<TTopDonorCardPlace> = ({ value }) => {
  const color = useMemo(() => {
    if (value === 1) return { iconColor: "#F9DA62", textColor: "#FFFFFF" };
    if (value === 2) return { iconColor: "#A6B3CE", textColor: "#FFFFFF" };
    if (value === 3) return { iconColor: "#ED9564", textColor: "#FFFFFF" };
    return { iconColor: "#F4F5F6", textColor: "#4E5355" };
  }, [value]);

  return (
    <div className={styles.TopDonorCardPlace}>
      <div
        className={styles.TopDonorCardPlace_Text}
        style={{ color: color.textColor }}
      >
        {value}
      </div>
      <DropImage color={color.iconColor} />
    </div>
  );
};

type TDropImage = {
  color: string;
};

const DropImage: React.FC<TDropImage> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="52.5"
      viewBox="0 0 40 52.5"
      fill="none"
    >
      <path
        d="M20 0L18.5384 1.35042C6.24736 12.7063 0 22.6219 0 31.3379C0 43.6807 9.10456 52.4999 20 52.5C30.8955 52.5 40 43.6807 40 31.3379C40 22.6219 33.7527 12.7063 21.4616 1.35042L20 0Z"
        fill={color}
      />
    </svg>
  );
};

export default TopDonorCardPlace;
